import useVisitorLocation from "@/hooks/useVisitorLocation";
import { continentOf } from "@/lib/continents";

/**
 * The visitor's country (ISO2) and continent ("africa", "americas",
 * "europe", "asia" or "oceania"), from the country Toukky's server reads off
 * their address — the answer that already picks the site's language and
 * currency. Both are null while the answer is awaited (`loading`) or when
 * there is none.
 */
export default function useVisitorContinent() {
  const { loading, country_code: country } = useVisitorLocation();
  return { loading, country: country || null, continent: continentOf(country) };
}
